import React, { useState, forwardRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
    CollapsiblePanel,
    CollapsiblePanelBody,
    CollapsiblePanelHeader,
    PadContainer,
} from 'smartsuite-ui';
import DashboardFiltersModal from './DashboardFiltersModal';
import { useLabelContext } from '../hooks/labelContext';

const PageFilters = forwardRef((props, ref) => {
    const { dashboardLabels } = useLabelContext();
    const [isPageFiltersCollapsed, setIsPageFiltersCollapsed] = useState(
        !props.defaultOpen
    );

    useEffect(() => {
        setIsPageFiltersCollapsed(!props.defaultOpen);
    }, [props.defaultOpen]);

    function onCollapse() {
        setIsPageFiltersCollapsed((prevState) => !prevState);
    }

    return (
        <PadContainer cssClassModifiers={['pad-medium', 'no-pad-left-right']}>
            <CollapsiblePanel
                isCollapsed={isPageFiltersCollapsed}
                onCollapse={onCollapse}
            >
                <CollapsiblePanelHeader
                    autoHideRollupText={false}
                    headerLabel={dashboardLabels.dashboardFilters}
                    rollupText={props.rollupText}
                >
                    {props.children}
                </CollapsiblePanelHeader>
                <CollapsiblePanelBody>
                    <DashboardFiltersModal
                        {...props}
                        ref={ref}
                        collapseFilters={() => setIsPageFiltersCollapsed(true)}
                    />
                </CollapsiblePanelBody>
            </CollapsiblePanel>
        </PadContainer>
    );
});

PageFilters.propTypes = {
    availableFilters: PropTypes.instanceOf(Object),
    children: PropTypes.node,
    defaultOpen: PropTypes.bool,
    filterValues: PropTypes.instanceOf(Object).isRequired,
    rollupText: PropTypes.string,
    showMeasureFilters: PropTypes.bool.isRequired,
    showPrecisionConfig: PropTypes.bool.isRequired,
    showTimeAndPrecision: PropTypes.bool.isRequired,
    timeAndPrecision: PropTypes.instanceOf(Object).isRequired,
    whereClauses: PropTypes.instanceOf(Array).isRequired,
};

PageFilters.defaultProps = {
    availableFilters: {},
    children: null,
    defaultOpen: false,
    rollupText: '',
};

export default PageFilters;
